import api from './api';

export const questionService = {
  // Get a specific question by ID
  async getQuestion(questionId) {
    const response = await api.get(`/questions/${questionId}`);
    return response.data;
  },

  // Create a new question (admin only)
  async createQuestion(questionData) {
    const response = await api.post('/questions/', questionData);
    return response.data;
  },

  // Update a question (admin only)
  async updateQuestion(questionId, questionData) {
    const response = await api.put(`/questions/${questionId}`, questionData);
    return response.data;
  },

  // Delete a question (admin only)
  async deleteQuestion(questionId) {
    const response = await api.delete(`/questions/${questionId}`);
    return response.data;
  },

  // Import questions from CSV (admin only)
  async importQuestionsCSV(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/questions/import-csv', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};